// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"ku-z","giftOrPromoSelector":"lu-z","disabled":"mu-z","subTitle":"nu-z","selectShipAddressMessage":"ou-z","changePayment":"pu-z"};